import { useEffect } from 'react';
import { SEO, SITE_URL } from '../constants/seo';
import { useLanguage } from '../i18n/LanguageContext';

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

// Per-page SEO: unique title, meta description, canonical, Open Graph, robots.
// Follows the active UI language so titles/descriptions are always translated.
export const useSEO = (pageKey) => {
  const { lang } = useLanguage();
  useEffect(() => {
    const page = SEO[pageKey];
    if (!page) return;
    const { title, desc } = page[lang] || page.ro;
    document.title = title;
    setMeta('name', 'description', desc);
    setMeta('name', 'robots', page.noindex ? 'noindex, nofollow' : 'index, follow');
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:url', `${SITE_URL}${page.path}`);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'Domidoor Solutions');
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', `${SITE_URL}${page.path}`);
  }, [pageKey, lang]);
};
